import StudentData from './StudentData/StudentData';
import './StudentDataStep.css';
import { useRequestdata } from '../../../useRequestData';
import Disclaimer from '../../../../../components/Disclaimer/Disclaimer';
import { t } from 'i18next';
import React from 'react';
import { useRequestType } from '../../../../../shared/hooks/useRequestType';

const StudentDataStep: React.FC = () => {
  const { isExternal } = useRequestType();
  return (
    <div className="REQXXI-StudentDataStep">
      <div className="REQXXI-StudentDataStep-Student">
        <StudentData requestData={useRequestdata({})} />
      </div>
      {isExternal && (
        <Disclaimer text={t('equivalencyRequestDisclaimer')} />
      )}
    </div>
  );
};

export default StudentDataStep;
